import TextEffectsSharedMapper from '../../TextEffectsShared/viewer/TextEffectsShared.mapper';
import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

const css = withCompInfo()(
  ['compId', 'styleProperties'],
  ({ compId, styleProperties }) => {
    return {
      '--layer-blend-mode': styleProperties['layer-blend-mode'].replace(
        /:([\w-]+)/,
        `:$1-${compId}`,
      ),
      '--bevel-angle': styleProperties['bevel-angle'].replace(
        /:(\d+)/,
        `:$1-${compId}`,
      ),
    };
  },
);

export default createComponentMapperModel({
  ...TextEffectsSharedMapper,
  css,
});
